import * as React from "react";

import { hot } from "react-hot-loader";
import { BrowserRouter } from "react-router-dom";

import { Root } from "./Root";
import { BASE_PATH } from "./routes";

const Application = () => (
  <BrowserRouter basename={BASE_PATH}>
    <Root />
  </BrowserRouter>
);

export default process.env.NODE_ENV === "production"
  ? Application
  : hot(module)(Application);
